import PageTitle from "UIPalette/PageTitle/PageTitle";
import { t } from "i18next";
import { useTwoColumnLayout } from "shared/core/hooks/useTwoColumnLayout";
import useSupportData from "./hooks/useSupportData";
import { useWisdomLite } from "core/hooks/useWisdomLite";
import { useEnhancedChat } from "./hooks/useEnhancedChat";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";

export enum MediaPermissions {
  CAMERA = "camera",
  MICROPHONE = "microphone",
}

export const Support = () => {
  useNavBarContext({ title: t("pageTitleOverride.support") });
  useEnhancedChat();
  const { isWisdomLite } = useWisdomLite();
  const allComponents = useSupportData();
  const layout = useTwoColumnLayout(allComponents);

  return (
    <>
      <PageTitle title={t("pageTitle.support.home")} />
      <div className="space-y-4">
        <div className="space-y-2 mb-10">
          <p>{t("support.headingParagraphOne")}</p>
          <p>
            {t("support.headingParagraphTwo")} {!isWisdomLite ? t("support.headingParagraphOptions") : null}
          </p>
        </div>
        {layout}
      </div>
    </>
  );
};
